module.exports = __webpack_public_path__ + "media/images/icon_list/pin-3d4523ff63b8cede54362abb3ab1a1bd.svg";